import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useDispatch } from "react-redux";

import { Case, CaseDocumentWithPresignedUrl } from "pwapi";

import { openDocument } from "shared/actions/caseDetailActions";
import { useLISFinalizedDiagnosis } from "shared/hooks/useDiagnosis";
import { CaseDetailState } from "shared/reducers/caseDetailReducer";

import LinkButton from "components/LinkButton";

import { getLatestReportVersion } from "./dialogs/utils";

interface DocsGridProps {
  caseDetail: CaseDetailState;
}

export const OldItem = ({
  caseDetail,
  document,
}: {
  caseDetail: CaseDetailState;
  document: CaseDocumentWithPresignedUrl;
}) => {
  const dispatch = useDispatch();

  return (
    <li>
      <LinkButton
        nocolor
        disabled={caseDetail?.deadDocIds.indexOf(document.id || 0) !== -1}
        onClick={() => {
          caseDetail.id &&
            dispatch(openDocument(caseDetail.id, document.id || 0));
        }}
      >
        {document.wpl_document_metadata &&
        Object.keys(document.wpl_document_metadata)?.length ? (
          <strong>
            {document.wpl_document_metadata.type}
            {document.wpl_document_metadata.type !==
              document.wpl_document_metadata.comment &&
              document.wpl_document_metadata.comment && (
                <> {document.wpl_document_metadata.comment}</>
              )}
          </strong>
        ) : (
          <strong>{document.name?.replace(".pdf", "")}</strong>
        )}
        &nbsp;&ndash;&nbsp;
        <span>{new Date(document.created_at || "").toLocaleDateString()}</span>
      </LinkButton>
    </li>
  );
};

const DocsGrid = ({ caseDetail }: DocsGridProps) => {
  const documents = caseDetail.documents.filter(
    (d) => d.status === CaseDocumentWithPresignedUrl.status.UPLOADED
  );

  const finalized_report_id =
    caseDetail.source === Case.source.PW
      ? getLatestReportVersion(
          caseDetail,
          CaseDocumentWithPresignedUrl.category.CASE_REPORT
        )?.id
      : useLISFinalizedDiagnosis(caseDetail)?.finalized_report_id;
  const finalReportDocument = documents.find(
    (d) => d.id === finalized_report_id
  );
  const removedFinalDocuments = finalReportDocument
    ? [
        ...documents.filter(
          (d) =>
            d.category !== CaseDocumentWithPresignedUrl.category.CASE_REPORT
        ),
      ]
    : [...documents];

  const prelimReport = documents.find(
    (d) => d.id === caseDetail.prelim_report_id
  );
  const removePrelimDocuments = prelimReport
    ? removedFinalDocuments.filter(
        (d) =>
          d.category !==
          CaseDocumentWithPresignedUrl.category.PRELIMINARY_REPORT
      )
    : removedFinalDocuments;

  // If there is a preliminary report or final report, only show the latest one, remove all others.
  const leftoverDocuments = [
    ...removePrelimDocuments,
    ...(!!prelimReport
      ? [
          {
            ...prelimReport,
            name: "Preliminary Report",
          },
        ]
      : []),
    ...(!!finalReportDocument
      ? [
          {
            ...finalReportDocument,
            name: "Final Report",
          },
        ]
      : []),
  ];
  const requisitionForm = leftoverDocuments.find(
    (d) => d.category === CaseDocumentWithPresignedUrl.category.REQUISITION_FORM
  );
  const is_diagnostic = caseDetail.accession_prefix?.is_diagnostic;

  return (
    <div className="DocsGrid">
      <span className="Uploads">
        Uploads{" "}
        <span style={{ opacity: 0.6 }}>({leftoverDocuments.length})</span>{" "}
        {!requisitionForm && is_diagnostic && (
          <FontAwesomeIcon icon="exclamation-circle" color="var(--red)" />
        )}{" "}
        <strong style={{ fontSize: "larger" }}>▾</strong>
        <ul>
          {!requisitionForm && is_diagnostic && (
            <li className="Uploads__missing">
              <FontAwesomeIcon icon="exclamation-circle" color="var(--red)" />{" "}
              Missing Requisition Form
            </li>
          )}
          {leftoverDocuments.map((document, index) => (
            <OldItem
              key={`${document.name}${index}`}
              document={document}
              caseDetail={caseDetail}
            />
          ))}
        </ul>
      </span>
    </div>
  );
};

export default DocsGrid;
